import { Group } from '@visx/group'
import { Line, Polygon } from '@visx/shape'
import cx from 'classnames'

import { TRIANGLE_HEAD_RADIUS } from './constants'
import type { Coordinate } from './types'

type Props = {
  from: Coordinate
  to: Coordinate
  isActive: boolean
}

export const ExpandedReplacementPath = ({ from, to, isActive }: Props) => (
  <Group className={cx('group/replacement-path', { active: isActive })}>
    <Line
      className="stroke-inheritance stroke-2 group-hover/replacement-path:stroke-3 group-[.active]/replacement-path:stroke-3"
      from={from}
      to={{ x: from.x, y: to.y }}
    />
    <Line
      className="stroke-inheritance stroke-2 group-hover/replacement-path:stroke-3 group-[.active]/replacement-path:stroke-3"
      from={{ x: from.x, y: to.y }}
      to={to}
    />
    <Polygon
      sides={3}
      className="fill-inheritance stroke-inheritance stroke-2 group-hover/replacement-path:stroke-3 group-[.active]/replacement-path:stroke-3"
      size={TRIANGLE_HEAD_RADIUS}
      center={{
        y: to.y,
        x:
          from.x < to.x
            ? to.x - TRIANGLE_HEAD_RADIUS
            : to.x + TRIANGLE_HEAD_RADIUS,
      }}
      rotate={to.x < from.x ? 180 : 0}
    />
  </Group>
)
